export default "__VITE_ASSET__bFkKcUhg__"